import { render, staticRenderFns } from "./CompanyProfileRedesign.vue?vue&type=template&id=ba5a1da4&scoped=true"
import script from "./CompanyProfileRedesign.vue?vue&type=script&lang=js"
export * from "./CompanyProfileRedesign.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileRedesign.vue?vue&type=style&index=0&id=ba5a1da4&prod&lang=css"
import style1 from "./CompanyProfileRedesign.vue?vue&type=style&index=1&id=ba5a1da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5a1da4",
  null
  
)

export default component.exports